import { render, staticRenderFns } from "./tooltipContratos.vue?vue&type=template&id=a72d4956&scoped=true"
import script from "./tooltipContratos.vue?vue&type=script&lang=js"
export * from "./tooltipContratos.vue?vue&type=script&lang=js"
import style0 from "./tooltipContratos.vue?vue&type=style&index=0&id=a72d4956&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72d4956",
  null
  
)

export default component.exports